import React from 'react'
import TransporterTable from '../../components/customerComponent/transporterTable'
function onboardTransporter(props) {
    return (
        <React.Fragment>
            <div className="ag-theme-material agOver" style={{ width: '100%', height: '100%' }}>
                <TransporterTable locationHistory={props} />
            </div>
        </React.Fragment>
    )
}

export default onboardTransporter

